import React, { useState } from 'react';
import EventIcon from '../assets/event_icon.png';
import EventModal from './EventModal';

export default function AnnouncementButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'absolute',
          top: 310,
          right: 0,
          zIndex: 1200,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
        }}
      >
        <img src={EventIcon} alt="Annoucement" style={{ width: 70, height: 70 }} />
      </button>
      <EventModal
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
